const styles = {
  wrap: {
    width: '100%',
  },
  label: {
    fontSize: 14,
    lineHeight: '18px',
    fontFamily: "'Proxima Nova', 'Open Sans', 'Montserrat', sans-serif",
    display: 'flex',
    justifyContent: 'space-between',
    alignItems: 'center',
  },
  input: {
    width: '100%',
    '& input': {
      border: '1px solid #E2E2FC',
      borderRadius: 8,
      padding: '0 9px',
      backgroundColor: '#FFFFFF',
      width: '100%',
      height: 40,
      fontSize: 16,
      fontFamily: "'Proxima Nova', 'Open Sans', 'Montserrat', sans-serif",
      '&::-webkit-input-placeholder ': {
        color: '#697077',
        fontWeight: '400',
        fontFamily: "'Proxima Nova', 'Open Sans', 'Montserrat', sans-serif",
        opacity: 1,
      },
      '&:-ms-input-placeholder': {
        color: '#697077',
        fontWeight: '400',
        fontFamily: "'Proxima Nova', 'Open Sans', 'Montserrat', sans-serif",
        opacity: 1,
      },
      '&::placeholder': {
        color: '#697077',
        fontWeight: '400',
        fontFamily: "'Proxima Nova', 'Open Sans', 'Montserrat', sans-serif",
        opacity: 1,
      },
    },
  },
  error: {
    fontSize: 12,
    color: '#FF0000',
    marginBottom: 1,
  },
  emptyMargin: {
    height: 16,
  },
  description: {
    color: '#707087',
    fontSize: 12,
    fontWeight: 400,
    lineHeight: '18px',
    fontFamily: "'Proxima Nova', 'Open Sans', 'Montserrat', sans-serif",
    marginTop: '2px',
    fontStyle: 'italic',
  },
}
export { styles }
